// @ts-expect-error - react-grid-layout does not have type declarations
import type { Layouts } from "react-grid-layout";
import { type IdentityApiSdk, type Role, type TokenResponse } from "@packsize/identity-api-sdk";

import { type TenantTimezone } from "@/schemas";
import { packNetAxios } from "@/lib/api-client";
import { baseRoutes } from "@/api/base-routes";
import { type WidgetId } from "@/views/dashboard/dashboard-widgets";

export type DashboardData = {
	layouts?: Layouts;
	selectedWidgets?: WidgetId[];
};

export const getTenantTimezone = async (client: IdentityApiSdk): Promise<TenantTimezone> => {
	const response = await client.getTenantTimezone();

	// return tenantTimezoneSchema.parse(response.data); test parse
	return response.data as TenantTimezone;
};

export const getUserDashboard = async (client: IdentityApiSdk): Promise<DashboardData> => {
	const response = await client.getUserDashboardApi();
	// return dashboardDataSchema.parse(response.responseData); test parse
	return response.responseData as DashboardData;
};

export const saveSelectedWidgets = async (client: IdentityApiSdk, widgets: number[]): Promise<void> => {
	// const validatedRequest = z.array(z.string()).parse(widgets.map(String)); // TODO: Test parse
	await client.saveSelectedWidgetsApi(widgets.map(String));
};

export const saveDashboardLayout = async (client: IdentityApiSdk, layouts: Layouts): Promise<void> => {
	// const validatedRequest = z.record(z.string(), z.any()).parse(layouts); // TODO: Test parse
	await client.saveDashboardLayoutApi(layouts);
};

export async function getVersion(): Promise<string> {
	const response = await packNetAxios.get<string>(`${baseRoutes.identity}/v1/oauth/token/version`);

	return response.data;
}

export const getTenantRoles = async (client: IdentityApiSdk): Promise<Role[]> => {
	const result = await client.getRoles();

	if (!result.success || result.data === undefined) {
		throw new Error("Failed to get roles");
	}

	return result.data;
};

export const getCompanyRoles = async (): Promise<Role[]> => {
	const response = await packNetAxios.get(`${baseRoutes.identity}/v2/roles`);

	if (response.status !== 200) {
		throw new Error(response.statusText);
	}

	return response.data as Role[];
};

export const getSiteToken = async (siteId: string): Promise<TokenResponse> => {
	const response = await packNetAxios.get<TokenResponse>(`${baseRoutes.identity}/v1/oauth/token/site/${siteId}`);

	if (response.status !== 200) {
		throw new Error("Failed to get site token");
	}

	return response.data;
};
